/**
 * Registry of the consolidated backend's deploy units (Cloud Run service = entrypoint basename
 * plus a stage suffix, both carried by the env value). Also imported by vite.config.ts in Node
 * to build the local dev proxy, so keep it free of imports and side effects. start-local.sh
 * hardcodes these ports — keep them in lockstep.
 */
export interface BackendServiceDefinition {
  /** Env var holding the service's base URL for the current environment. */
  envVar: string;
  /** Local dev port; the Vite proxy target. */
  localPort: number;
}

// Deployed, browser-facing entrypoints only: private APIs are IAM-only with no CORS, and a
// migrating service is added by the ticket that migrates it.
export const BACKEND_SERVICES = {
  'internal-public-api': {envVar: 'VUE_APP_INTERNAL_PUBLIC_API_URL', localPort: 3101},
  'external-public-api': {envVar: 'VUE_APP_EXTERNAL_PUBLIC_API_URL', localPort: 3102},
} as const satisfies Record<string, BackendServiceDefinition>;

export type BackendServiceName = keyof typeof BACKEND_SERVICES;
